import { DEFAULT_LANGUAGE, LANG } from "../../config/Lang";

const DAIRECT_URL = "https://dairect.io";

type DairectTrackingOptions = {
  campaign: string;
  medium: string;
  content?: string;
  locale?: string;
  path?: string;
  source?: string;
  term?: string;
};

export function buildDairectUrl({
  campaign,
  medium,
  content,
  locale,
  path = "/",
  source = "takyon",
  term,
}: DairectTrackingOptions): string {
  const normalizedPath = path.startsWith("/") ? path : `/${path}`;
  const pathname = locale
    ? `/${resolveDairectLocale(locale)}${normalizedPath}`
    : normalizedPath;
  const url = new URL(pathname, DAIRECT_URL);

  url.searchParams.set("utm_source", source);
  url.searchParams.set("utm_medium", medium);
  url.searchParams.set("utm_campaign", campaign);

  if (content) {
    url.searchParams.set("utm_content", content);
  }

  if (term) {
    url.searchParams.set("utm_term", term);
  }

  return url.toString();
}

export function resolveDairectLocale(locale?: string): LANG {
  const normalizedLocale = locale?.split("-")[0].toLowerCase();

  if (
    normalizedLocale &&
    Object.values(LANG).includes(normalizedLocale as LANG)
  ) {
    return normalizedLocale as LANG;
  }

  return DEFAULT_LANGUAGE;
}

export function buildLocalizedDairectUrl(
  locale?: string,
  path: string = "/",
): string {
  const normalizedPath = path.startsWith("/") ? path : `/${path}`;
  const url = new URL(
    `/${resolveDairectLocale(locale)}${normalizedPath}`,
    DAIRECT_URL,
  );

  url.searchParams.set("utm_source", "takyon");

  return url.toString();
}

export { DAIRECT_URL };
